export default {"src":"/_next/static/media/MyProfileChevronDown.43414bc1.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};